module.exports = __webpack_public_path__ + "img/43.9c4e65cd.png";